// import ConnectionLostModal from '../utils/ConnectionLost';

// const enigma = require('enigma.js');
// const schema = require('enigma.js/schemas/12.170.2.json');
// const SenseUtilities = require('enigma.js/sense-utilities');

// const config = {
//   host: 'qdt.qlik.com',
//   // host: 'sense-demo.qlik.com',
//   appId: '288cdb78-f6f5-4912-8940-a5eeb6315bf4', // 2023
// };

// const url = SenseUtilities.buildUrl(config);
// const session = enigma.create({ schema, url });

// session.on('closed', () => {
//   // eslint-disable-next-line no-console
//   console.error('Qlik Sense Session ended!');
//   const refreshUrl = window.location;
//   const timeoutMessage = 'Lost connection. Please refresh to continue.';
//   ConnectionLostModal({ refreshUrl, timeoutMessage });
// });

// // Export a function instead of a promise
// export default function openSession() {
//   return session.open().then((global) => global.openDoc(config.appId));
// }

const enigma = require('enigma.js');
const schema = require('enigma.js/schemas/12.170.2.json');
const SenseUtilities = require('enigma.js/sense-utilities');

const config = {
  host: 'sense-demo.qlik.com',
  appId: 'b50be8f2-90d5-4ba6-9dd5-5d6db9a9cfc1',
};
const url = SenseUtilities.buildUrl(config);
const session = enigma.create({ schema, url });

export default session.open().then((global) => global.openDoc(config.appId));
